import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitButton', 'hiddenField'];

  connect() {
    // Garantir que o botão inicie desabilitado
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.setAttribute('disabled', 'true');
    }

    // Escutar evento customizado do TrailForms
    document.addEventListener('alternativeSelected', this.handleAlternativeSelected.bind(this));
  }

  handleAlternativeSelected(event) {
    this.enableSubmitButton(event.detail.alternativeId);
  }

  enableSubmitButton(alternativeId) {
    console.log('Habilitando botão para alternativa:', alternativeId);

    // Atualizar campo hidden
    if (this.hasHiddenFieldTarget && alternativeId) {
      this.hiddenFieldTarget.value = alternativeId;
    }

    // Habilitar botão e atualizar estilos
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.removeAttribute('disabled');

      // Remover classes de botão desabilitado
      this.submitButtonTarget.classList.remove(
        'tw-opacity-60',
        'tw-bg-coolGray-400',
        'tw-text-coolGray-600',
      );

      // Adicionar classes de botão habilitado (primary scheme)
      this.submitButtonTarget.classList.add(
        'tw-bg-primary-400',
        'tw-text-white',
        'hover:tw-bg-primary-300',
        'active:tw-translate-y-1',
        'hover:tw-translate-y-0.5',
      );

      // Atualizar a borda (padding) do botão
      const buttonContainer = this.submitButtonTarget.parentElement;
      const paddingElement = buttonContainer.querySelector('div:last-child');
      if (paddingElement) {
        // Remover classe de padding desabilitado (que não existe quando disabled)
        // Adicionar classe de padding habilitado
        paddingElement.classList.add('tw-bg-primary-700');
      }
    }
  }
}
